import AddEditpaymentConfiguration from './AddEditPaymentConfiguration';

export default AddEditpaymentConfiguration;
